module.exports = __webpack_public_path__ + "img/requirement.0a330339.png";